import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";

const ease = [0.16, 1, 0.3, 1] as const;

const QuoteSection = () => {
  const { t } = useTranslation();

  return (
    <section className="section-padding" style={{ background: "var(--gradient-subtle)" }}>
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
          className="max-w-3xl mx-auto text-center"
        >
          <Quote size={36} className="text-primary/30 mx-auto mb-6 rotate-180" />

          <blockquote className="font-display font-bold text-foreground text-2xl sm:text-3xl md:text-4xl leading-snug mb-6">
            {t.quote.text}{" "}
            <span className="text-gradient">{t.quote.accent}</span>
          </blockquote>

          <p className="text-muted-foreground font-body text-sm sm:text-base leading-relaxed max-w-xl mx-auto">
            {t.quote.body}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default QuoteSection;
